'use strict';

function setConsent(result) {
    var trackingConsentData = $('.tracking-consent');

    var url = trackingConsentData.data(result);
    var tokenName = trackingConsentData.data('tokenname');
    var token = trackingConsentData.data('token');
    var data = {};
    data[tokenName] = token;
    $.ajax({
        url: url,
        type: 'post',
        data: data,
        dataType: 'json',
        success: function (response) {
            if (response.success) {
                $('.cookie').fadeOut(300);
            }
        },
        error: function (err) {
            // Expected error response is for CSRF failure, which will include a redirect to CSRF-Fail
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
        }
    });
}

function setGoogleConsent() {
    // 環境別設定対策
    // 本番環境以外ではgtag関数が存在しない場合があるため
    if (typeof gtag == 'function') {
        // GTM同意モード更新
        gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'analytics_storage': 'granted'
        });
    }
}

$(() => {
    // Google GA4を設定する
    setGoogleConsent();

    if ($('.tracking-consent').data('tracking') === null && $('.tracking-consent').hasClass('api-true')) {
        $('.cookie').css('display', 'flex');
    }

    $('body').on('click', '.jsCookieYes', function(e) {
        e.preventDefault();
        setConsent('accept');
    });

    $('body').on('click', '.jsCookieNo', function(e) {
        e.preventDefault();
        setConsent('reject');
    });
});
